import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p){
  const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; // Size of grid squares

  // Draw grid much larger than canvas so it doesn't "run out" during camera movement
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
      p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
      p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

const Lovefeel = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {

  function sketch(p) {
    // --- Variables ---
    let BLACK = [51, 51, 51];
    let PINK = [235, 93, 123];
    let BLUE = [93, 105, 235];
    let BEIGE = [255, 254, 246];

    let firstText = "Love is not only something you feel";
    let secondText = "it is something you do.";

    let latoFont;
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    const letter_extra_space = {
      a: 1, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
      k: 1, l: 0.5, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
      u: 1, v: 0, w: 1, x: 1, y: 1, z: 1,
      A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1,
      K: 1, L: 0.5, M: 1, N: 1, O: 1, P: 1, Q: 1, R: 1, S: 1, T: 1,
      U: 1, V: 1, W: 1, X: 1, Y: 1, Z: 1
    };

    let angle = 0;
    let morph = 0;
    let delayFrames = 170;
    let baseRadius = 100;
    let targetRadius = 125;

    let noiseScale = 1;
    let noiseSpeed = 0.02;

    // Load Google Font
    function preloadFont(url) {
      return new Promise((resolve) => {
        const link = document.createElement("link");
        link.href = url;
        link.rel = "stylesheet";
        link.onload = resolve;
        document.head.appendChild(link);
      });
    }

    p.setup = async () => {
      await preloadFont("https://fonts.googleapis.com/css2?family=Lato&display=swap");

      try {
        latoFont = "Lato";
      }
      catch {
        latoFont = "sans-serif";
      }
      
      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textSize(fs);
      p.textAlign(p.LEFT, p.CENTER);
      p.textFont(latoFont);


    
      // Precompute char widths
      feelWidths = firstText.split("").map((ch) => {
        const w = p.textWidth(ch);
        return w + (ch === " " ? spaceKerning : (letter_extra_space[ch] || 0));
      });

      doWidths = secondText.split("").map((ch) => {
        const w = p.textWidth(ch);
        return w + (ch === " " ? spaceKerning : (letter_extra_space[ch] || 0));
      });

    };

    function drawShape() {
      p.push();
      p.translate(p.width / 2, p.height / 2);

      let currentSize = p.lerp(baseRadius, targetRadius, morph);
      let n = p.lerp(2, 100, morph);
      let fillColor = p.frameCount <= delayFrames ? p.color(...PINK) : p.color(...BLUE);

      p.noStroke();
      p.fill(fillColor);

      p.push();
      if (morph < 0.01) {
        p.rotate(angle);
        angle += 0.01;
      }

      p.beginShape();
      let points = 200;

      for (let i = 0; i < points; i++) {
        let theta = p.map(i, 0, points, 0, p.TWO_PI);
        let noiseAmp = (1 - morph) * 15;

        let noiseFactor =
          noiseAmp * (p.noise(Math.cos(theta) * noiseScale, Math.sin(theta) * noiseScale, p.frameCount * noiseSpeed) - 0.5);

        let rUnit = Math.pow(
          Math.pow(Math.abs(Math.cos(theta)), n) +
          Math.pow(Math.abs(Math.sin(theta)), n),
          -1 / n
        );

        let r = rUnit * currentSize + noiseFactor;
        let x = r * Math.cos(theta);
        let y = r * Math.sin(theta);
        p.vertex(x, y);
      }

      p.endShape(p.CLOSE);
      p.pop();
      p.pop();

      if (p.frameCount > delayFrames && morph < 1) morph += 0.005;
    }

    function drawTextAnimated() {
      p.push();
      try {
        latoFont = "Lato";
      }
      catch {
        latoFont = "sans-serif";
      }

      p.textFont(latoFont);

      let centerX = p.width / 2;
      let feelY = p.height - 120;

      // first line
      let feelTotal = feelWidths.reduce((a, b) => a + b);
      let x = centerX - feelTotal / 2;
      let visible = p.frameCount <= delayFrames
        ? Math.floor(p.map(p.frameCount, 0, delayFrames, 0, firstText.length))
        : 0;

      for (let i = 0; i < firstText.length; i++) {
        p.fill(i < visible ? PINK : BLACK);
        p.text(firstText[i], x, feelY);
        x += feelWidths[i];
      }

      // second line
      let doY = feelY + 24;
      let doTotal = doWidths.reduce((a, b) => a + b);
      x = centerX - doTotal / 2;

      let visible2 =
        p.frameCount > delayFrames
          ? Math.floor(p.map(morph, 0, 1, 0, secondText.length))
          : 0;

      for (let i = 0; i < secondText.length; i++) {
        p.fill(i < visible2 ? BLUE : BLACK);
        p.text(secondText[i], x, doY);
        x += doWidths[i];
      }

      p.pop();
    }

    p.draw = () => {
      p.background(...BEIGE);
      grid(p);
      drawShape();
      drawTextAnimated();
    };
  }


  return <div style={{ backgroundColor: bgcolor }}>
    <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
      <ReactP5Wrapper sketch={sketch} />
    </div>
  </div>
};

export default Lovefeel